import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
import './index.css';

// StrictMode is on. The Base44 build left it off, which hid a login redirect
// being fired as a side effect during render.
//
// This used to await a /api/config fetch before rendering anything, because
// the Supabase connection details were not known at build time. Authentication
// is local now, so the shell paints immediately and the session check happens
// behind it.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
